var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('oly-header'),_c('v-content',[_c('router-view')],1),_c('oly-footer'),_c('basket-snackbar'),(_vm.$route.name !== 'switch_customer' && _vm.customerCount > 1)?_c('switch-customer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }